module.exports = __webpack_public_path__ + "assets/img/title-ed2534bb.png";